// ****** SOUBORwebapp\src\index.js ******

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
// === NOVÁ ZMĚNA: IMPORT FONTU PRO GLOBÁLNÍ REGISTRACI ===
import { Font } from '@react-pdf/renderer'; 

// === NOVÁ ZMĚNA: GLOBÁLNÍ REGISTRACE FONTŮ ===
// Předpokládá se, že .ttf soubory jsou umístěny v 'public/fonts/roboto/'
Font.register({
  family: 'Roboto',
  fonts: [
    { src: '/fonts/roboto/Roboto-Regular.ttf', fontWeight: 'normal' },
    { src: '/fonts/roboto/Roboto-Bold.ttf', fontWeight: 'bold' },
    { src: '/fonts/roboto/Roboto-Italic.ttf', fontStyle: 'italic' },
    { src: '/fonts/roboto/Roboto-BoldItalic.ttf', fontWeight: 'bold', fontStyle: 'italic' },
  ],
});

Font.register({
  family: 'RobotoCondensed',
  fonts: [
    { src: '/fonts/roboto/Roboto_Condensed-Regular.ttf', fontWeight: 'normal' },
    { src: '/fonts/roboto/Roboto_Condensed-Bold.ttf', fontWeight: 'bold' },
    { src: '/fonts/roboto/Roboto_Condensed-Italic.ttf', fontStyle: 'italic' },
    { src: '/fonts/roboto/Roboto_Condensed-BoldItalic.ttf', fontWeight: 'bold', fontStyle: 'italic' },
  ],
});

Font.register({
  family: 'RobotoSemiCondensed',
  fonts: [
    { src: '/fonts/roboto/Roboto_SemiCondensed-Regular.ttf', fontWeight: 'normal' },
    { src: '/fonts/roboto/Roboto_SemiCondensed-Bold.ttf', fontWeight: 'bold' },
    { src: '/fonts/roboto/Roboto_SemiCondensed-Italic.ttf', fontStyle: 'italic' },
    { src: '/fonts/roboto/Roboto_SemiCondensed-BoldItalic.ttf', fontWeight: 'bold', fontStyle: 'italic' },
  ],
});
// ===============================================

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();